// Module to generate a flight overview
'use strict'
import { getCityName } from '../util/helpers.js';

class FlightOverview {

    constructor() {
        this.append = this.append.bind(this);
        this.getPriceRange = this.getPriceRange.bind(this);
        this.getCarbonRange = this.getCarbonRange.bind(this);
        this.displayTitle = this.displayTitle.bind(this);
        this.translateMonth = this.translateMonth.bind(this);
    }

    getPriceRange() {
        // TODO: Do robust error checking here (for string manipulations)
        //  Add error message in flight overview if prices data cannot be calculated
        const prices = document.getElementsByClassName('price-container');
        let pricesArr = [];
        let currency = '$';

        if(prices === null || prices === undefined || prices.length === 0) {
            return;
        } else {
            currency = prices[0].innerHTML.substr(0,1)
        }

        Array.prototype.forEach.call(prices, function(pricesDiv, index) { 
            let price = pricesDiv.innerHTML;
            price = price.replace(/,/g, '');
            pricesArr[index] = Number(price.substr(1, price.length));
        }, null);

        let minPrice = Math.min.apply(null, pricesArr);
        let maxPrice = Math.max.apply(null, pricesArr);
        return {
            min: minPrice,
            max: maxPrice,
            currency: prices[0].innerHTML.substr(0,1)
        };
    }

    getCarbonRange() {
        // Find the carbon range (disregard the errors)
        const carbons = document.getElementsByClassName('carbon-container');
        let carbonsArr = [];

        Array.prototype.forEach.call(carbons, function(carbonDiv, index) { 
            let carbonHTML = carbonDiv.innerHTML; 
            if(!carbonHTML.includes('NaN')) {
                const carbonValue = Number(carbonHTML.substr(0, carbonHTML.indexOf('k')));
                if(carbonValue) {
                    carbonsArr.push(carbonValue);
                }
            }
        }, null);

        let minCarbon = Math.min.apply(null, carbonsArr);
        let maxCarbon = Math.max.apply(null, carbonsArr);
        console.log(minCarbon, maxCarbon);
        return {
            min: minCarbon,
            max: maxCarbon
        };
    }

    update(rawData) {
        const flightTitle = this.displayTitle(rawData);
        document.getElementById('overview-title').replaceChild(flightTitle, document.getElementById('flight-overview-title'));
        /*
        
        // Construct and initialize the DOM elements
        let priceRange = document.getElementById('content1');
        let carbonRange = document.getElementById('content2');
        const prices = this.getPriceRange();
        const carbon = this.getCarbonRange();

        priceRange.innerHTML = `<b>Price Range: </b>
                                ${prices.currency}${prices.min.toLocaleString()} ~
                                ${prices.currency}${prices.max.toLocaleString()}`;
        carbonRange.innerHTML = `<b>Carbon Range: </b>
                                ${carbon.min.toFixed(2)} ~
                                ${carbon.max.toFixed(2)}
                                Kg CO${'2'.sub()}`;
        */
    }

    append(rawData) {
        window.global.state.ready = true;

        const flightTitle = this.displayTitle(rawData);
        document.getElementById('overview-title').appendChild(flightTitle); 

        /*
        let flightTitle = document.createElement('h1');
        flightTitle.id = 'flight-overview-title';
        flightTitle.innerHTML = `${originName} (${originIATA}) to ${destName} (${destIATA})`;
        */
        
    }

    displayTitle(rawData){

        //getting the origin and dest from JSON file istead of search box
        const tripOption = rawData.body.trips.tripOption;    
        // Create the flight overview title
        const segment = tripOption[0].slice[0].segment;
        const legInLastSeg = segment[segment.length-1].leg; //segment's & leg's array length can be > 1
        const originIATA = segment[0].leg[0].origin; // origin code is in the first leg of the first segment 
        const destIATA = legInLastSeg[legInLastSeg.length-1].destination;   //destination code is in the last leg of last segment 
        const originName = getCityName(originIATA, rawData);    //get the city name corresponding to the city code from JSON response
        const destName = getCityName(destIATA, rawData);    //get the city name corresponding to the city code from JSON response

        const slice = tripOption[0].slice;
        const isRoundTrip = (slice.length == 2);

        let departureDate = slice[0].segment[0].leg[0].departureTime;
        let returnDate = null;

        departureDate = departureDate.split('T')[0];
        departureDate = departureDate.split('-');
        departureDate[1] = this.translateMonth(departureDate[1]);
        /*
        note: 
            departYear = departureDate[0];
            departMonth = departureDate[1];
            departDay = departureDate[2];
        */

        let flightTitle = document.createElement('div');
        flightTitle.id = 'flight-overview-title';

        if (isRoundTrip){
            returnDate = slice[slice.length-1].segment[0].leg[0].departureTime;
            returnDate = returnDate.split('T')[0];
            returnDate = returnDate.split('-');
            returnDate[1] = this.translateMonth(returnDate[1]);
            flightTitle.innerHTML = 
            `<h1 id="overview-origin-title">${originName} (${originIATA})</h1>
                    <img src="assets/images/plane_gradient.png" width="50px"/> to 
                        <h2 class="flight-overview-keywords"> ${destName} (${destIATA})</h2> on 
                        <h2 class="flight-overview-keywords" id="dDate">${departureDate[1]} ${departureDate[2]} ${departureDate[0]}</h2> return 
                        <h2 class="flight-overview-keywords" id="rDate">${returnDate[1]} ${returnDate[2]} ${returnDate[0]}</h2>`; 
            return flightTitle;
        }
        
        //one-way
        flightTitle.innerHTML = 
        `<h1 id="overview-origin-title">${originName} (${originIATA})</h1>
                <img src="assets/images/plane_gradient.png" width="50px"/> to 
                    <h2 class="flight-overview-keywords"> ${destName} (${destIATA})</h2> on 
                    <h2 class="flight-overview-keywords" id="dDate">${departureDate[1]} ${departureDate[2]} ${departureDate[0]}</h2>`
        return flightTitle;
    }

    translateMonth(month){
        var monthInText;
        switch (month){
            case "01": 
                monthInText = "Jan";
                break;
            case "02":
                monthInText = "Feb";
                break;
            case "03": 
                monthInText = "Mar";
                break;
            case "04":
                monthInText = "Apr";
                break;
            case "05": 
                monthInText = "May";
                break;
            case "06":
                monthInText = "Jun";
                break;
            case "07": 
                monthInText = "Jul";
                break;
            case "08":
                monthInText = "Aug";
                break;
            case "09": 
                monthInText = "Sep";
                break;
            case "10":
                monthInText = "Oct";
                break;
            case "11": 
                monthInText = "Nov";
                break;
            case "12":
                monthInText = "Dec";
                break;
        }
        return monthInText;
    }

}

export default FlightOverview



// WEBPACK FOOTER //
// ./components/FlightOverview.js